import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import accessLogReducer from 'pages/access-log/store/accessLogSlice';
import historyPageSlice from 'pages/history/stores/historyPageSlice';
import managerRecordingSlice from 'pages/manager-recordings/store/managerRecordingSlice';
import managerRoleReducer from 'pages/manager-roles/store/managerRoleSlice';
import managerSystemReducer from 'pages/manager-systems/store/managerSystemSlice';
import managerUserSipReducer from 'pages/manager-users-SIP/store/managerUserSipSlice';
import managerUserReducer from 'pages/manager-users/store/managerUserSlice';
import managerWhiteboardReducer from 'pages/manager-whiteboard/store/managerWhiteboardSlice';
import managerSubsSlice from 'pages/subtitles/components/Table/store/managerSubsSlice';
import meetingMonitorReducer from 'pages/system-monitor/store/meetingMonitorSlice';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import managerMeetingSlice from 'pages/manager-meeting/managerMeetingSlice';
import modelPeriodSlice from '../pages/manager-meeting/modelPeriodSlice';
import whiteboardShareListSlice from '../pages/manager-whiteboard/share-board/whiteboardShareListSlice';
import whiteboardListSlice from '../pages/manager-whiteboard/whiteboardListSlice';
import commonSlice from './commonSlice';
import dialogSlice from './dialogSlice';
import accountInfoSlice from './user/accountInfo';
import userInfoSlice from './user/userInfoSlice';
import userSIPSlice from './user/userSIPSlice';
import userSlice from "./user/userSlice";
import packageManagementSlice from 'pages/service-package-management/store/packageManagementSlice';
import managerEventSlice from 'pages/content-landingpage/store/managerEventSlice';
import backupSlice from 'pages/manager-backup/stores/backupSlice';
import managerVersionSlice from 'pages/manager-version/store/managerVerionSlice';
import loginSlice from 'pages/authentication/login/loginSlice';
import themeSlice from './themeSlice';
import mcuSlice from './mcuSlice';
import organizationTreeSlice from './organizationTreeSlice';
import phonebookSlice from 'pages/phonebook/store/phonebookSlice';
import groupUserSlice from 'pages/phonebook/store/groupUserSlice';
import layoutSlice from './layoutSlice';
import sessionReducer from './sessionSlice';
import { PERSISTENCE_VERSION } from './persistence';
import { createRootReducer } from './rootReducer';

const persistCurrentUser = {
    key: 'currentUser',
    version: PERSISTENCE_VERSION,
    storage
};

const persistTheme = {
    key: 'theme',
    version: PERSISTENCE_VERSION,
    storage,
    whitelist: ['initialConfig', 'isVMPTheme'],
}
const persistedReducer = persistReducer(persistCurrentUser, userSlice);
const persistedReducerTheme = persistReducer(persistTheme, themeSlice);

const appReducer = combineReducers({
        packageManagement: packageManagementSlice,
        currentUser: persistedReducer,
        theme: persistedReducerTheme,
        whiteboardList: whiteboardListSlice,
        whiteboardShareList: whiteboardShareListSlice,
        modelPeriod: modelPeriodSlice,
        userInfo: userInfoSlice,
        userSIP: userSIPSlice,
        dialog: dialogSlice,
        accountInfo: accountInfoSlice,
        managerSubs: managerSubsSlice,
        session: sessionReducer,
        accesslog: accessLogReducer,
        manageruser: managerUserReducer,
        managerusersip: managerUserSipReducer,
        managerrole: managerRoleReducer,
        managersystem: managerSystemReducer,
        meetingmonitor: meetingMonitorReducer,
        managerwhiteboard: managerWhiteboardReducer,
        managerMeeting: managerMeetingSlice,
        managerRecording: managerRecordingSlice,
        historyPage: historyPageSlice,
        common: commonSlice,
        managerEvent: managerEventSlice,
        backup: backupSlice,
        managerVersion: managerVersionSlice,
        login: loginSlice,
        mcu: mcuSlice,
        organizationTree: organizationTreeSlice,
        phonebook: phonebookSlice,
        groupUsers: groupUserSlice,
        layout: layoutSlice
    });

const rootReducer = createRootReducer(appReducer);

const store = configureStore({
    reducer: rootReducer,
    middleware:
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        })
})
export { rootReducer };
export default store;
